import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { POST } from "@/services/activity-requests";
import { toast } from "sonner";
import { removeMultipleKeys } from "@/utils/function";
import { tokenRefresh } from "@/redux/Refresh";
interface CompletionData {
  [key: string]: any;
}

interface CompletionState {
  data: CompletionData;
  loading: boolean;
  error: string | null;
}

interface CompletionArgs {
  token: string;
  activityValue: {
    levelId: string | number;
    lessonId: string | number;
  };
  time: string;
  id: string | number;
  accuracy: number;
}

const initialState: CompletionState = {
  data: {},
  loading: false,
  error: null,
};

export const completionFn = createAsyncThunk<
  CompletionData,
  CompletionArgs,
  { rejectValue: string }
>(
  "activityCompletion",
  async ({ token, activityValue, time, id, accuracy }, { rejectWithValue }) => {
    const raw = JSON.stringify({
      levelId: activityValue.levelId,
      lessonId: activityValue.lessonId,
      accurracy: accuracy,
      timeToComplete: time,
      language: "igbo",
    });
    // console.warn(raw);
    try {
      const { response } = await POST(`/activities-progress`, raw, token);
      return response;
    } catch (err: unknown) {
      const error = err as any;
      if (error.response?.status === 401) {
        removeMultipleKeys([
          "pluri_token",
          "pluri_refresh_token",
          "user_detail",
        ]);
        toast.error("Session expired. Please log in again.", {
          id: "session-expired-toast",
          richColors: true,
        });
        window.location.href = "/login";
      }
      const errorMessage = error.response?.data?.message || "Unknown error";
      console.warn(err);
      return rejectWithValue(errorMessage);
    }
  }
);

const completionSlice = createSlice({
  name: "completion",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(completionFn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        completionFn.fulfilled,
        (state, action: PayloadAction<CompletionData>) => {
          state.data = action.payload;
          state.loading = false;
          state.error = null;
        }
      )
      .addCase(
        completionFn.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Unknown error";
        }
      );
  },
});

export default completionSlice.reducer;
